import React, { useEffect, useState } from "react";

const About = ({ onSubmit, editingData, onCancel }) => {
  const [formData, setFormData] = useState({
    heading: "",
    para: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (editingData) {
      setFormData({
        heading: editingData.heading,
        para: editingData.para,
        image: null,
      });
      setImagePreview(editingData.imagePreview || null);
    }
  }, [editingData]);

  const validate = () => {
    if (!formData.heading.trim().endsWith("$")) {
      setError("Heading must end with '$'");
      return false;
    }
    if (!formData.para.trim().endsWith("$")) {
      setError("Paragraph must end with '$'");
      return false;
    }
    return true;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setFormData({ ...formData, image: file });
      setImagePreview(URL.createObjectURL(file));
      setError("");
    } else {
      setError("Please upload a valid image file.");
      setFormData({ ...formData, image: null });
      setImagePreview(null);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const entry = {
      heading: formData.heading,
      para: formData.para,
      imagePreview: formData.image
        ? URL.createObjectURL(formData.image)
        : editingData?.imagePreview || null,
    };

    onSubmit(entry);
  };

  return (
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3>{editingData ? "Edit Entry" : "Create Entry"}</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Heading</label>
                  <input
                    type="text"
                    name="heading"
                    className="form-control"
                    value={formData.heading}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Paragraph</label>
                  <textarea
                    name="para"
                    className="form-control"
                    rows="4"
                    value={formData.para}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={handleImageChange}
                  />
                  {imagePreview && (
                    <div className="mt-2">
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%", borderRadius: 8 }}
                      />
                    </div>
                  )}
                </div>

                {error && <div className="text-danger">{error}</div>}

                <div className="mt-3">
                  <button type="submit" className="btn btn-primary me-2">
                    {editingData ? "Update" : "Create"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
